export enum CorpStatus {
  REGISTER = 1,
  FORM_COMPANY_PROCESSING,
  FORM_CEO_PROCESSING,
  FORM_BUSINESS_PROCESSING,
  FORM_COMPLETE = 5,
  PROCESSING = 10,
  CONFIRMED = 20
}
